export { default as AccountSettingsPageTiles } from './AccountSettingsPageTiles';
